import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from '../../../../shared/services/console.service';
import { ModalSeleccionarClienteComponent } from '../../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from '../../../shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { ModalAddeditDescuentosComponent } from './modal-addedit-descuentos.component';
import gql from 'graphql-tag';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { IMyOptions, MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-descuentos-especiales',
  templateUrl: './descuentos-especiales.component.html',
  styleUrls: ['./descuentos-especiales.component.scss'],
  providers: [SecurityService],
})
export class DescuentosEspecialesComponent implements OnInit, OnDestroy {
  // // Inputs
  @Input() permiteUnidadNegocio: any = [];

  // Modales
  @ViewChild(ModalAddeditDescuentosComponent, { static: true }) agregarDescuentoModal: ModalAddeditDescuentosComponent;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent;

  // Form
  formData: FormGroup;

  // Constants
  readonly TIPO_CLIENTE: String = `_CLIENTE_`;
  readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  listaDescuentos: any = null;
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null;
  clientesSeleccionadosFormatted: String = null;
  tiposClientesSeleccionados: any = null;
  tiposClientesSeleccionadosFormatted: String = null;

  modalConfirmTitle: String = '';
  modalConfirmContent: String = '';
  FechaActual: string = '';
  // check Estado descuentos especiales
  readonly RO_EstadoActivo: boolean = true;
  readonly RO_EstadoInactivo: boolean = false;

  // Utils
  private log: any;
  private subs = new Subscription();

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('DCTOS-ESPECIALES');
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();
    this.paginationContext.RecordsByPage = 10;
    this.createForms();
    this.formChangesSubscriptions();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  trackByDescuentoCodigo(index: number, item: any) {
    return item && item.codigo != null ? item.codigo : index;
  }

  /********* FORMS *********/
  createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    console.log('initDate: ' + initDate);
    this.formData = this.fb.group({
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      fechaInicio: [initDate],
      fechaFin: [currentDate],
      rutCliente: [''],
      estadoAct: [this.RO_EstadoActivo],
    });
  }

  private formChangesSubscriptions() {
    this.subs.add(
      this.formData
        .get('rutCliente')
        .valueChanges.pipe(filter(Boolean), debounceTime(1000))
        .subscribe((rutCliente: string) => {
          this.modalSeleccionarCliente.searchByRut(rutCliente);
        })
    );
    this.subs.add(
      this.formData.get('buscarPor').valueChanges.subscribe((buscarPor) => {
        this.log('change ', buscarPor);
        this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside();
      })
    );
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null;
    this.clientesSeleccionadosFormatted = null;
  }

  limpiarBuscarPorTiposClientes() {
    this.tiposClientesSeleccionados = null;
    this.tiposClientesSeleccionadosFormatted = null;
    this.modalSeleccionarCliente.cleanLast();
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null;
    this.tiposClientesSeleccionados = null;
  }

  abrirModalSeleccion() {
    if (this.formData.get('buscarPor').value === this.TIPO_CLIENTE) this.abrirModalSeleccionarCliente();
    else if (this.formData.get('buscarPor').value === this.TIPO_TIPO_CLIENTE) this.abrirModalSeleccionarClientesTipos();
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected();
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected();
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados);
  }

  abrirModalAgregarDescuento() {
    this.agregarDescuentoModal.show('ADD');
  }

  cerrarModalAgregarDescuento() {
    this.agregarDescuentoModal.hide();
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.log(origen, data)
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  // }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data);
    this.limpiarDataSeleccionada();
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data;
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map((p) => p.nombre).join(', ');
  }

  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada();
    this.formData.get('rutCliente').setValue('');
    this.clientesSeleccionados = [data];
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map((p) => p.nombre).join(', ');
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.log(origen, data);
    this.limpiarDataSeleccionada();
    this.tiposClientesSeleccionados = data;
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map((p) => p.descripcion).join(', ');
    this.log('onClienteTiposSeleccionado this.tiposClientesSeleccionadosFormatted', this.tiposClientesSeleccionadosFormatted);
  }
  /********* MODALS *********/

  /********* OPERATIONS *********/
  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.buscar();
  }

  buscar(fromStartPage: Boolean = false) {
    const { currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.FechaActual = currentDate;

    if (fromStartPage) this.paginationContext.CurrentPage = 1;
    // this.validateAllFormFields(this.formData);
    // if (!this.formData.valid) {
    //   return
    // }

    const esTipoCliente = this.formData.get('buscarPor').value === this.TIPO_TIPO_CLIENTE;

    const inputData = {
      filtroExacto: {
        exacto: {
          cabecera: {
            codigo: -1,
            rut_empresa: Number(this.rutEmpresa),
            sucursal_codigo: Number(this.sucursalEmpresa),
            fecha_inicio: this.formData.get('fechaInicio').value || '0001-01-01',
            fecha_termino: this.formData.get('fechaFin').value || '0001-01-01',
            tipo_cliente: [],
            rut_cliente_multiple: [],
            activado: this.formData.get('estadoAct').value,
          },
          detalleClientes: [],
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };
    if (esTipoCliente && this.tiposClientesSeleccionados) {
      inputData.filtroExacto.exacto.cabecera.tipo_cliente = this.tiposClientesSeleccionados.map((tipo) => ({ codigo: tipo.codigo }));
    } else if (this.clientesSeleccionados) {
      inputData.filtroExacto.exacto.detalleClientes = this.clientesSeleccionados.map((cliente) => ({ cliente_proveedor_rut: cliente.rut }));
    }

    this.log(JSON.stringify(inputData));

    this.loaded = false;
    this.loading = true;
    this.listaDescuentos = [];

    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($filtroExacto: FiltroInputTypeOfdescuentoDTOdescuentoDTOInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            descuento {
              obtenerSegunFiltro(filtro: $filtroExacto, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  registros {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_inicio
                    fecha_termino
                    activado
                    descripcion
                    permiteEdicion
                  }
                  totalPaginas
                  totalRegistros
                }
              }
            }
          }
        `,
        variables: inputData,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.descuento.obtenerSegunFiltro;
        // self.log(respuesta)
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        self.paginationContext.RecordsCount = totalRegistros;
        self.paginationContext.CurrentPage = paginaActual;
        self.paginationContext.PagesCount = totalPaginas;
        // self.log(self.paginationContext)
        self.listaDescuentos = registros;
        //  self.data.map(cliente => { cliente.rutFormato = self.rutService.AgregarDV(cliente.rut) })
        self.loaded = true;
        self.loading = false;
      }
    );
  }

  ver({ rut_empresa, sucursal_codigo, codigo }) {
    this.log(Number(this.rutEmpresa), codigo);
    this.agregarDescuentoModal.load(rut_empresa, sucursal_codigo, codigo, false);
  }

  editar({ rut_empresa, sucursal_codigo, codigo }) {
    this.log(Number(this.rutEmpresa), codigo);
    this.agregarDescuentoModal.load(rut_empresa, sucursal_codigo, codigo, true);
  }

  confirmDuplicar(codigo: number) {
    this.modalConfirmTitle = 'Duplicar descuento';
    this.modalConfirmContent = '¿Desea duplicar el descuento?';
    this.modalConfirm.show(() => {
      this.duplicar(codigo);
    });
  }

  duplicar(codigo: number) {
    const inputData = {
      cabecera: {
        codigo,
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
      },
      detalleClientes: [],
      detalleProductos: [],
    };

    const self = this;
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoDTOInputType) {
            descuento {
              clonarDescuento(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_inicio
                    fecha_termino
                    activado
                    descripcion
                  }
                  detalleClientes {
                    cliente_proveedor_rut
                    sucursal_codigo
                    rut_empresa
                    direccion_codigo
                    descuento_codigo
                  }
                  detalleProductos {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    descuento_cliente_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: inputData,
        },
      },
      function (_respuesta) {
        self.log(_respuesta);
        const { mensajes, respuesta } = _respuesta.data.descuento.clonarDescuento;
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        } else {
          self.toastrService.success('Descuento duplicado con éxito');
          self.buscar(true);
        }
        // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
        //   alert('Registro grabado');
        //   self.editarModalDtoComercielas.hide();
        // } else {
        //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
        // }
      }
    );
  }

  confirmDesactivar(codigo: number) {
    this.modalConfirmTitle = 'Desactivar descuento';
    this.modalConfirmContent = '¿Desea desactivar el descuento?';
    this.modalConfirm.show(() => {
      this.desactivar(codigo);
    });
  }

  desactivar(codigo: number) {
    const descuentoCliente = {
      codigo,
      rut_empresa: Number(this.rutEmpresa),
      sucursal_codigo: Number(this.sucursalEmpresa),
      rut_usuario: Number(this.accesolocalstorage.getRutUsuario()),
      activado: false,
    };

    const self = this;
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoInputType) {
            descuento {
              cambiarEstado(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  activado
                }
              }
            }
          }
        `,
        variables: {
          entidad: descuentoCliente,
        },
      },
      function (_respuesta) {
        self.log(_respuesta);
        const { mensajes, respuesta } = _respuesta.data.descuento.cambiarEstado;
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        } else {
          self.toastrService.success('Descuento desactivado con éxito');
          self.buscar(true);
        }
        // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
        //   alert('Registro grabado');
        //   self.editarModalDtoComercielas.hide();
        // } else {
        //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
        // }
      }
    );
  }

  onDescuentoSaved() {
    this.log('onDescuentoSaved');
    this.buscar(true);
  }
  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados);
  }

  /**LIMPIAR FILTRO */
  limpiarfiltros() {
    this.formValidatorsService.reset(this.formData);

    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formData.get('fechaInicio').setValue(initDate);
    this.formData.get('buscarPor').setValue(this.TIPO_CLIENTE);
    this.formData.get('estadoAct').setValue(this.RO_EstadoActivo);
    this.clientesSeleccionados = [];
  }
}
